// import Cookies from 'js-cookie'

const tokenName = process.env.VUE_APP_TOKEN_NAME || 'Authorization'
const Token = 'User-Token'

export function getToken() {
    return localStorage.getItem(tokenName)
}


export function setToken(token) {
    return localStorage.setItem(tokenName, token)
}

export function removeToken() {
    return localStorage.removeItem(tokenName)
}
